import React from "react";
import "./Experience.css";
import { motion } from "framer-motion";

const stats = [
  { value: "1+", label: "année d’expérience" },
  { value: "1+", label: "Projets réalisés" },
  { value: "1+", label: "Mission en entreprise" },
];

const experiences = [
  {
    company: "SocialIzus",
    role: "Développeuse React Native",
    period: "Alternance / stage",
    missions: [
      "Participation au développement d’une application de rencontre amicale sur Paris",
      "Apprentissage et mise en pratique des bases de React Native",
      "Collaboration avec l’équipe produit pour livrer des fonctionnalités concrètes",
    ],
    tech: ["React Native", "JavaScript", "Git"],
  },
];

function Experience() {
  return (
    <section className="experience section" id="Expérience">
      <div className="container">
        <div className="section-heading">
          <span>Mon</span>
          <span className="accent">expérience</span>
          <p className="section-copy">
            Des missions concrètes, une montée en compétences rapide et une
            approche professionnelle du développement.
          </p>
        </div>

        <div className="experience-stats">
          {stats.map((stat) => (
            <motion.article
              className="achievement"
              key={stat.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="circle">{stat.value}</div>
              <span>{stat.label}</span>
            </motion.article>
          ))}
        </div>

        <div className="experience-timeline">
          {experiences.map((item) => (
            <article className="experience-card" key={item.company}>
              <div className="experience-meta">
                <h3>{item.company}</h3>
                <p className="experience-role">{item.role}</p>
                <span className="experience-period">{item.period}</span>
              </div>
              <ul>
                {item.missions.map((mission) => (
                  <li key={mission}>{mission}</li>
                ))}
              </ul>
              <div className="experience-tech">
                {item.tech.map((tech) => (
                  <span key={tech}>{tech}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
